"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("../Pagination/Pagination"));
var ResultsListConfig_1 = __importDefault(require("../../constants/ResultsListConfig"));
var deviceHelper_1 = require("../../helpers/deviceHelper");
var Dropdown_1 = __importDefault(require("../Dropdown"));
var SortPagination_1 = __importDefault(require("./SortPagination"));
var PostListLayout_1 = __importDefault(require("./PostListLayout"));
var PostList = function (_a) {
    var _b;
    var getPosts = _a.getPosts, posts = _a.posts, title = _a.title, layout = _a.layout, dealType = _a.dealType, onUpdateToTop = _a.onUpdateToTop, handleOpenEditPage = _a.handleOpenEditPage, onRemove = _a.onRemove, onAddBookmark = _a.onAddBookmark, onRemoveBookmark = _a.onRemoveBookmark, handleSortChange = _a.handleSortChange, sortBy = _a.sortBy, onStatistic = _a.onStatistic, handleOpenPostPreviewBySlug = _a.handleOpenPostPreviewBySlug, hideBookmarks = _a.hideBookmarks, previewUrl = _a.previewUrl;
    var postListRef = react_1.useRef(null);
    var t = react_i18next_1.useTranslation('common').t;
    var executeScroll = function () { return scrollToRef(postListRef); };
    var SORT_BY = ResultsListConfig_1.default.SORT_BY;
    var paginationAvailable = react_1.useMemo(function () {
        if (posts === null || posts === void 0 ? void 0 : posts.total) {
            return Math.ceil(posts.total / posts.per_page) > 1;
        }
    }, [posts]);
    var sortOptions = react_1.useMemo(function () {
        return SORT_BY.OPTIONS.map(function (optionKey) {
            var translationKey = SORT_BY.TRANSLATION_NAMESPACE + '.' + optionKey;
            return {
                key: optionKey,
                text: t(translationKey),
            };
        });
    }, [SORT_BY]);
    var listSummary = react_1.useMemo(function () {
        if (posts) {
            return posts.total > 1
                ? posts.total + ' ' + t('SEARCH_SUMMARY.results')
                : posts.total + ' ' + t('SEARCH_SUMMARY.result');
        }
    }, [posts]);
    var scrollToRef = function (ref) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };
    var onPageChange = function (activePage) {
        if (activePage === void 0) { activePage = 1; }
        executeScroll();
        getPosts(activePage);
    };
    return (react_1.default.createElement("div", { ref: postListRef, className: "post-list" },
        title && react_1.default.createElement("h1", { title: title }, title),
        react_1.default.createElement("div", { className: "information" },
            layout === 'SEARCH' && (react_1.default.createElement("div", { className: "results-count" }, false ? listSummary : '')),
            layout === 'SEARCH' && ((_b = posts) === null || _b === void 0 ? void 0 : _b.total) ? (react_1.default.createElement("div", { className: "actions" },
                !deviceHelper_1.isMobile() ? (react_1.default.createElement("div", { className: "sort" },
                    react_1.default.createElement("span", null, t('SORT.sort_by')),
                    react_1.default.createElement(Dropdown_1.default, { onChange: handleSortChange, itemKey: "key", itemValue: "text", list: sortOptions, selected: sortBy || 'date_desc' }))) : null,
                react_1.default.createElement(SortPagination_1.default, { posts: posts, getPosts: getPosts }))) : null),
        react_1.default.createElement("div", { className: "posts layout-" + layout.toLowerCase() },
            react_1.default.createElement(PostListLayout_1.default, { posts: posts, layout: layout, handleOpenEditPage: handleOpenEditPage, onUpdateToTop: onUpdateToTop, onRemove: onRemove, onAddBookmark: onAddBookmark, onRemoveBookmark: onRemoveBookmark, onStatistic: onStatistic, handleOpenPostPreviewBySlug: handleOpenPostPreviewBySlug, hideBookmarks: hideBookmarks, previewUrl: previewUrl })),
        paginationAvailable && posts && (react_1.default.createElement(Pagination_1.default, { onPageChange: onPageChange, totalPages: Math.ceil(posts.total / posts.per_page), active: posts.current_page }))));
};
exports.default = PostList;
